import React from  'react';
import {Route, Routes  } from "react-router-dom";
import { ProtectedRoute } from "./components";
import SLUGS from './slugs';
import Content from "../Content"
import Paperbase from '../Paperbase';
import DrawingPage from '../DrawingPage';

export const RouterConfig = () =>{
    return(
        <Routes>            
            {/* <Route path = {SLUGS.visualisering} element={<Paperbase/>}/>     */}
            {/* <ProtectedRoute exact path = {SLUGS.profileInfo} component={ProfileContainer}/>  
            <ProtectedRoute exact path = {SLUGS.users} component={UserContainer}/>
            <ProtectedRoute exact path = {SLUGS.newUser} component={UserFormPage}/>   
            <ProtectedRoute path = {SLUGS.editUser} component = {UserFormPage}/>            
            <ProtectedRoute exact path = {SLUGS.customerHandling} component={CustomerContainer}/>
            <ProtectedRoute exact path = {SLUGS.newCustomer} component={CustomerFormPage}/>   
            <ProtectedRoute path = {SLUGS.editCustomer} component = {CustomerFormPage}/>              */}
            <Route path = {SLUGS.root} element= {<DrawingPage/>}/>
        </Routes >
    );
};

export default RouterConfig;